import React from "react";
import { useNavigate } from "react-router-dom"; // Add this import

import EntityToolbar from "common/admin/EntityToolbar";
import { useEvent } from "event/hooks/useEvent";
import { useEventFormContext } from "event/context/event.form.context";

import {
  useAddEventMutation,
  useRemoveEventMutation,
  useUpdateEventMutation,
} from "event/api/event.api";
import { Menu } from "@mantine/core";
import { Copy } from "tabler-icons-react";

function EventToolbar() {
  const event = useEvent();
  const form = useEventFormContext();
  const navigate = useNavigate(); // Add this hook

  const addEventMutation = useAddEventMutation();
  const updateEventMutation = useUpdateEventMutation();
  const removeEventMutation = useRemoveEventMutation();

  const handleDuplicate = () => {
    const valuesToExclude: (keyof typeof form.values)[] = [
      "bingo_game_id",
      "crossbar_event_id",
      "crossbar_id",
      "pronostics_v2_id",
    ]; //add the fields you want to exclude

    const duplicatedValues = { ...form.values };

    // Remove excluded fields
    valuesToExclude.forEach((field) => {
      delete duplicatedValues[field as keyof typeof duplicatedValues];
    });

    // Set default values for specific fields
    const defaultValues = {
      pog_candidates: [null, null, null, null],
      pog_vote_ended: false,
    };

    // Merge duplicated values with default values
    const finalValues = {
      ...duplicatedValues,
      ...defaultValues,
      name: duplicatedValues.name + "(1)",
    };

    navigate("./../new", {
      state: {
        from: finalValues,
      },
    });
  };

  return (
    <EntityToolbar
      entity={event}
      form={form}
      addMutation={addEventMutation}
      updateMutation={updateEventMutation}
      removeMutation={removeEventMutation}
      label="événement"
      showDuplicate={false}
    >
      {/* This will replace the default duplicate functionality */}
      <Menu.Item icon={<Copy size={14} />} onClick={handleDuplicate}>
        Duplicate
      </Menu.Item>
    </EntityToolbar>
  );
}

export default EventToolbar;
